import { render, staticRenderFns } from "./DataCardSmall.vue?vue&type=template&id=ea1406ae&scoped=true&"
import script from "./DataCardSmall.vue?vue&type=script&lang=js&"
export * from "./DataCardSmall.vue?vue&type=script&lang=js&"
import style0 from "./DataCardSmall.vue?vue&type=style&index=0&id=ea1406ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea1406ae",
  null
  
)

export default component.exports